import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { isLandingDocumentPath } from '@constants/publicSearch';

/**
 * Resets window scroll when the route pathname changes.
 * React Router does not do this by default, so a long landing scroll
 * would otherwise carry over to /terms, /privacy, etc.
 * The landing page owns scroll for `/` and its section URLs.
 */
export function ScrollToTop() {
  const location = useLocation();
  const { pathname, hash } = location;
  const scrollTo = (location.state as { scrollTo?: string } | null)?.scrollTo;

  useEffect(() => {
    if (isLandingDocumentPath(pathname)) {
      return;
    }
    if (hash) {
      return;
    }
    if (scrollTo) {
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash, scrollTo]);

  return null;
}
